import React, { useState } from 'react';
import SpinnerOverlay from '../../components/Spinner/SpinnerOverlay';
import { useNotifications } from '../../contexts/notificationContext';
import BillOfMaterialModel from '../../models/BillOfMaterialModel';
import ItemSearchResult from '../../models/ItemSearchResult';
import DataService from '../../services/data.service';
import { DataResult } from '../../types/Result';
import ItemRevisionCard from './Components/ItemRevisionCard';
import ItemFilterForm, { ItemSearchCriteria } from './FilterForm/ItemFilterFormAdvanced';
import ItemFilterFormAdvanced from './FilterForm/ItemFilterFormAdvanced';

interface ItemMiniProps {
    projectId?: number
    projectTypeId?: number
    productCategoryId?: number
    forBom: boolean
    bom?: BillOfMaterialModel
    handleItemClicked: (itemRevision: ItemSearchResult) => void
}

const ItemSearchMiniView: React.FC<ItemMiniProps> = ({ handleItemClicked, projectId, projectTypeId, productCategoryId, forBom, bom }) => {
    const [items, setItems] = useState<ItemSearchResult[]>([])
    const { handleResult, handleException } = useNotifications();
    const [showSpinner, setShowSpinner] = useState<boolean>(false);

    function search(criteria: ItemSearchCriteria) {
        setShowSpinner(true)
        DataService
            .post<DataResult<ItemSearchResult[]>>(`api/v1/ItemRevisions/Search/`, criteria)
            .then(response => {
                setShowSpinner(false)
                handleResult(response);
                if (response.isSuccesful === true && response.data) {
                    setItems(response.data);
                    if (response.data.length === 1) {
                        handleItemClicked(response.data[0]);
                    }
                }
            })
            .catch(e => {
                setShowSpinner(false)
                handleException(e)
            });
    }

    let results = items.map((item, index) => {
        return <ItemRevisionCard itemRevision={item} handleItemClicked={handleItemClicked} key={index} index={index} />
    });

    return (
        <div className='main-content'>
            {/*<ItemFilterForm handleSearch={search} projectId={projectId} projectTypeId={projectTypeId} productCategoryId={productCategoryId} forBom={forBom} />*/}
            <ItemFilterFormAdvanced handleSearch={search} projectId={projectId} projectTypeId={projectTypeId} productCategoryId={productCategoryId} forBom={forBom} bom={bom} />
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-around' }}>
                {results}
            </div>
            {showSpinner && (<SpinnerOverlay />)}
        </div>
    );
}
export default ItemSearchMiniView;